import { Drawer } from 'theme';

class HeaderSidebarGrouped extends Drawer {
  connectedCallback() {
    super.connectedCallback();
    const { signal } = this.abortController;

    this.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-menu-open]');
      if (opener) this.openPanel(opener);
      if (event.target.closest('[data-menu-back]')) this.showMain(true);
    }, { signal });

    this.addEventListener('dialog:after-hide', () => this.showMain(), { signal });
    this.addEventListener('shopify:block:select', () => this.showMain(), { signal });
  }

  openPanel(opener) {
    const panel = this.querySelector(`#${CSS.escape(opener.getAttribute('aria-controls'))}`);
    if (!panel) return;

    this.mainScrollTop = this.getShadowPartByName('body').scrollTop;
    this.activeOpener = opener;
    this.querySelector('[data-menu-main]').hidden = true;
    this.querySelectorAll('[data-menu-panel]').forEach((item) => { item.hidden = item !== panel; });
    this.querySelectorAll('[data-menu-open]').forEach((item) => {
      item.setAttribute('aria-expanded', String(item === opener));
    });
    this.querySelector('[data-menu-title]').hidden = true;
    const back = this.querySelector('[data-menu-back]');
    this.querySelector('[data-menu-panel-title]').textContent = opener.dataset.menuLabel;
    back.hidden = false;
    this.getShadowPartByName('body').scrollTop = 0;
    back.focus({ preventScroll: true });
  }

  showMain(restoreFocus = false) {
    this.querySelector('[data-menu-main]').hidden = false;
    this.querySelectorAll('[data-menu-panel]').forEach((panel) => { panel.hidden = true; });
    this.querySelectorAll('[data-menu-open]').forEach((opener) => opener.setAttribute('aria-expanded', 'false'));
    this.querySelector('[data-menu-title]').hidden = false;
    this.querySelector('[data-menu-back]').hidden = true;
    this.getShadowPartByName('body').scrollTop = restoreFocus ? this.mainScrollTop || 0 : 0;
    if (restoreFocus) this.activeOpener?.focus({ preventScroll: true });
    this.activeOpener = null;
  }
}

if (!customElements.get('header-sidebar-grouped')) {
  customElements.define('header-sidebar-grouped', HeaderSidebarGrouped);
}
